import BeachIcon from './BeachIcon';
export default BeachIcon;
